import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import { useModal } from "../contexts/ModalContext";
import BodyContent from "../Modulos/ExamesOcupacionais/BodyContent";

const NewAso = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {

        openModal("asoSidebar")

    }

    return(
        <>
            <NavBar title="EXAMES OCUPACIONAIAS" setSideBar={ abrirMenuLateral } />
            <GenericBody>
                <BodyContent />
            </GenericBody>
        </>
    )
}

export default NewAso;